export default __webpack_public_path__ + "static/media/classroomAdmin-white.52b92ccb.svg";